// extracted by mini-css-extract-plugin
export var modal = "_jz-0";